import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const PRODUCTS_PROFILE_REQUESTS = gql`
  query GetProductProfiles {
    productProfiles(limit: 100, offset: 0) {
      data {
        codigo 
        master
        status
        dataCadastro
        descricao
        minima
        maxima
        tolerancia
        clienteMaster {
          codigo
          razaoSocial
        }
      }
      totalRecords
    }
  }
`;

export const getAllProductsProfile = async () => {
    
        const response = await queryAllPages(client, {
            query: PRODUCTS_PROFILE_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.productProfiles;
        return data;
    
}
